import {  Dialog, DialogActions, DialogContent, FormControl, Grid, Slider } from '@material-ui/core';
import { useState } from 'react';
import Cropper from 'react-easy-crop';
import { AiOutlineZoomIn, AiOutlineZoomOut } from 'react-icons/ai';
import styled from 'styled-components';


const StyledCropper = styled(Cropper)`
    
`;
const StyledDialogue = styled(Dialog)`
    .MuiDialog-paper{
        margin:0;
    }
    .MuiPaper-root {
        min-width: 300px;
        min-height: 350px;
    }
    .MuiSlider-root{
        color:#333333;
    }
    .MuiSlider-thumb{
        color:#2c97de;
    }
    .reactEasyCrop_Container{
        max-width: 400px;
        height: calc(100% - 140px);
        margin: 30px auto;
    }
    .MuiDialogActions-root{
        flex-direction:column;
    }
    @media(min-width: 768px){
        .MuiPaper-root {
            min-width: 450px;
            min-height:450px;
            border-radius:5px;
        }
    }
`;



const IconCropper = ({open, onClose, url, onSave, aspect, cropSize}) => {

    const [zoom, setZoom] = useState(1);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const onZoomChange = zoom => {
        setZoom(zoom)
    };

    const onCropChange = crop => {
        setCrop(crop);
    };

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const zoomIn = () => {
        setZoom(zoom + 0.1)
    }

    const zoomOut = () => {
        if(zoom > 1) {
            setZoom(zoom - 0.1)
        }
    }


    return <StyledDialogue open={open} onClose={onClose} >
        <DialogContent >
            <StyledCropper
                image={url}
                crop={crop}
                zoom={zoom}
                aspect={aspect || 1}
                onCropChange={onCropChange}
                onCropComplete={onCropComplete}
                onZoomChange={onZoomChange}
                mediaProps={{
                    height: '192px'
                }}
            />
        </DialogContent>
        <DialogActions style={{display: 'flex'}}>
            <FormControl style={{width: '100%'}} >
                <Grid container style={{justifyContent: 'center', gap: '15px', alignItems: 'center', cursor: 'pointer'}}>
                    <Grid item>
                        <AiOutlineZoomOut onClick={zoomOut} style={{fontSize: '25px'}} />
                    </Grid>
                    <Grid item style={{width: '60%'}}>
                        <Slider
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            aria-labelledby="Zoom"
                            onChange={(e, zoom) => onZoomChange(zoom)}
                        />
                    </Grid>
                    <Grid item  >
                        <AiOutlineZoomIn onClick={zoomIn} style={{fontSize: '25px'}} />
                    </Grid>
                </Grid>
                    
                </FormControl>
            <div className="my-2" style={{display:'flex', justifyContent:'flex-end', flexDirection: 'unset',  cursor: 'pointer'}} >
                <button className="btn btn-danger mr-2" onClick={onClose}>Close </button>
                <button className="btn btn-primary" onClick={() => onSave(croppedAreaPixels)}>Save </button>
                {/* <StyledButton
                        color="secondary"
                        onClick={onClose}
                    >
                    Cancel
                </StyledButton>
                <StyledButton
                    color="primary"
                    onClick={() => onSave(croppedAreaPixels)}
                >
                    Save
                </StyledButton> */}
            </div>
        </DialogActions>
    </StyledDialogue>
}

export default IconCropper;